module.exports = __webpack_public_path__ + "static/media/pink-brush.546e5f4f.jpg";